import { Injectable } from "@angular/core";

@Injectable()
export class WebViewProvider {
  constructor() {}

  showByUrl(url: string): void {
    window.open(url, "_blank");
  }

  showPrivacyPolicy(): void {
    window.open("https://www.paddy67.today/privacy_policy", "_blank");
  }

  showTerms(): void {
    window.open("https://www.paddy67.today/terms", "_blank");
  }

  showASCT(): void {
    window.open("https://www.paddy67.today/asct", "_blank");
  }

  showLoginWP(): void {
    window.open("https://paddy-media.com/manual/377/", "_blank");
  }
}



// WEBPACK FOOTER //
// ./src/providers/web-view/web-view.ts